import { useEffect, useRef } from "react";
import { createEventSourceConnection } from "../network/actions";

let globalEventSource = null;
let connectionCount = 0;
let chatMessageCallbackRef = null;

export default function useSSE({chatMessageCallback, nodeId}) {
  const mountedRef = useRef(false);

  useEffect(() => {
    if(chatMessageCallback){
      chatMessageCallbackRef = chatMessageCallback;
    }
  }, [chatMessageCallback, nodeId]);

  useEffect(() => {
    // Prevent multiple initializations in the same component instance
    if (mountedRef.current) {
      return;
    }

    mountedRef.current = true;
    connectionCount++;

    if (!globalEventSource) {
      globalEventSource = createEventSourceConnection();

      if (!globalEventSource) {
        return;
      }

      // For Concierge ChatMessages
      if(chatMessageCallbackRef && typeof chatMessageCallbackRef === "function"){
        globalEventSource.addEventListener("chatMessage", function (event) {
          try {
            const data = JSON.parse(event.data);
            chatMessageCallbackRef(data);
          } catch {
            console.log("Raw chat data:", event.data);
          }
        });
      }

    }

    // Cleanup
    return () => {
      mountedRef.current = false;
      connectionCount--;

      if (connectionCount === 0 && globalEventSource) {
        console.log("SSE disconnected");
        globalEventSource.close();
        globalEventSource = null;
        chatMessageCallbackRef = null;
      }
    };
  }, [nodeId]);

  return null;
}